module.exports = __webpack_public_path__ + "static/media/Profilephoto.1ab8f08e.svg";